import { SpeedCurve } from './speed-curve';

export class DetailObjAdditionalData {
    lat: number;
    long: number;
    speed_curve: SpeedCurve;
}